import { logs } from '@opentelemetry/api-logs';
import { LoggerProvider, LogRecordProcessor } from '@opentelemetry/sdk-logs';
import { resource } from './resource';

export function registerOtelLogging(processor?: LogRecordProcessor) {
  const loggerProvider = new LoggerProvider({
    resource,
    processors: processor ? [processor] : undefined,
  });

  logs.setGlobalLoggerProvider(loggerProvider);

  return loggerProvider;
}
